import { render, staticRenderFns } from "./show-more.vue?vue&type=template&id=0cf2152d&scoped=true&"
import script from "./show-more.vue?vue&type=script&lang=js&"
export * from "./show-more.vue?vue&type=script&lang=js&"
import style0 from "./show-more.vue?vue&type=style&index=0&id=0cf2152d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf2152d",
  null
  
)

export default component.exports